import { createFileRoute } from '@tanstack/react-router'
import LocationRequired from '@/features/errors/location-required'

export const Route = createFileRoute('/(auth)/location-required')({
  component: LocationRequired,
})
